module.exports = __webpack_public_path__ + "img/card-event-01-button.cf229e41.svg";